<template>
    <div class="relative inline-block">
      <span 
        class="text-gray-700 cursor-pointer" 
        @mouseover="showTooltip = true" 
        @mouseleave="showTooltip = false"
      >
        <slot></slot>
      </span>
      <div 
        v-if="showTooltip" 
        class="absolute z-10 p-2 text-white bg-gray-800 rounded-lg text-sm transition-opacity duration-300" 
        style="bottom: 110%; left: 50%; transform: translateX(-50%); white-space: nowrap;"
      >
        {{ text }}
        <!-- Piquito -->
        <div class="absolute left-1/2 transform -translate-x-1/2 w-2 h-2 bg-gray-800 rotate-45 bottom-[-4px]"></div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      text: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        showTooltip: false,
      };
    },
  };
  </script>  